import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { LinkedIn, Email, Phone, LocationOn } from "@mui/icons-material";

const Footer = () => {
  // const theme = useTheme();
  const currentYear = new Date().getFullYear();

  // const quickLinks = [
  //   { name: "Home", path: "/" },
  //   { name: "About Us", path: "/about" },
  //   { name: "Products", path: "/products" },
  //   { name: "Leadership", path: "/leadership" },
  //   { name: "Roadmap", path: "/roadmap" },
  //   { name: "Contact", path: "/contact" },
  // ];

  // const resources = [
  //   { name: "Blog", path: "/blog" },
  //   { name: "News & Updates", path: "/news" },
  //   { name: "Research Papers", path: "/research" },
  //   { name: "Case Studies", path: "/case-studies" },
  //   { name: "FAQs", path: "/faqs" },
  // ];

  // const legal = [
  //   { name: "Privacy Policy", path: "/privacy-policy" },
  //   { name: "Terms of Service", path: "/terms-of-service" },
  //   { name: "Cookie Policy", path: "/cookie-policy" },
  // ];

  return (
    <Box
      component="footer"
      sx={{ bgcolor: "primary.dark", color: "white", pt: 6, pb: 3 }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  ProtoDiag Solutions
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={{ mt: 2, mb: 3 }}>
              Empowering the Future of Telecom Communication
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <IconButton
                color="inherit"
                aria-label="LinkedIn"
                component="a"
                href="https://www.linkedin.com/company/protodiag-solutions-pvt-ltd/posts/?feedView=all"
                target="_blank"
              >
                <LinkedIn />
              </IconButton>
              {/* <IconButton
                color="inherit"
                aria-label="Twitter"
                component="a"
                href="https://twitter.com/protodiag"
                target="_blank"
              >
                <Twitter />
              </IconButton>
              <IconButton
                color="inherit"
                aria-label="Facebook"
                component="a"
                href="https://facebook.com/protodiag"
                target="_blank"
              >
                <Facebook />
              </IconButton> */}
            </Box>
          </Grid>

          {/* Quick Links */}
          {/* <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Quick Links
            </Typography>
            <List dense disablePadding>
              {quickLinks.map((link) => (
                <ListItem key={link.name} disablePadding disableGutters>
                  <ListItemText
                    primary={
                      <Link
                        component={RouterLink}
                        to={link.path}
                        color="inherit"
                        underline="hover"
                        sx={{ fontSize: "0.9rem" }}
                      >
                        {link.name}
                      </Link>
                    }
                    sx={{ mb: 0.5 }}
                  />
                </ListItem>
              ))}
            </List>
          </Grid> */}

          {/* Resources */}
          {/* <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Resources
            </Typography>
            <List dense disablePadding>
              {resources.map((link) => (
                <ListItem key={link.name} disablePadding disableGutters>
                  <ListItemText
                    primary={
                      <Link
                        component={RouterLink}
                        to={link.path}
                        color="inherit"
                        underline="hover"
                        sx={{ fontSize: "0.9rem" }}
                      >
                        {link.name}
                      </Link>
                    }
                    sx={{ mb: 0.5 }}
                  />
                </ListItem>
              ))}
            </List>
          </Grid> */}

          {/* Contact */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Contact Us
            </Typography>
            <List dense disablePadding>
              <ListItem disablePadding disableGutters sx={{ mb: 1 }}>
                <Email fontSize="small" sx={{ mr: 1 }} />
                <ListItemText primary="info@protodiag.com" />
              </ListItem>
              <ListItem disablePadding disableGutters sx={{ mb: 1 }}>
                <Phone fontSize="small" sx={{ mr: 1 }} />
                <ListItemText primary="+91-9899817807 / +91-9910274500" />
              </ListItem>
              <ListItem disablePadding disableGutters sx={{ mb: 1 }}>
                <LocationOn fontSize="small" sx={{ mr: 1 }} />
                <ListItemText primary="1st floor, A-5, Grovy Optiva, Block A, Sector 68, Noida, Basi Bahuddin Nagar, Uttar Pradesh 201316" />
              </ListItem>
            </List>

            {/* Legal Links */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                Legal
              </Typography>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                <Link
                  component={RouterLink}
                  to="/privacy-policy"
                  color="inherit"
                  underline="hover"
                  sx={{ fontSize: "0.8rem" }}
                >
                  Privacy Policy
                </Link>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: "rgba(255, 255, 255, 0.1)" }} />

        {/* Copyright */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="body2" color="rgba(255, 255, 255, 0.7)">
            © {currentYear} ProtoDiag Solutions Pvt. Ltd. All rights reserved. |
            Designed & Developed by ProtoDiag Tech Team
          </Typography>
          <Typography variant="body2" color="rgba(255, 255, 255, 0.7)">
            |
          </Typography>
          <Link
            component={RouterLink}
            to="/privacy-policy"
            color="inherit"
            underline="hover"
            sx={{
              fontSize: "0.875rem",
              color: "rgba(255, 255, 255, 0.7)",
              "&:hover": {
                color: "rgba(255, 255, 255, 0.9)",
              },
            }}
          >
            Privacy Policy
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
